import { render, staticRenderFns } from "./birth-datepicker.vue?vue&type=template&id=00318990&"
import script from "./birth-datepicker.vue?vue&type=script&lang=js&"
export * from "./birth-datepicker.vue?vue&type=script&lang=js&"
import style0 from "./components/birth-datepicker.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "birth-datepicker.vue"
export default component.exports